module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CREW_EXPERIENCE.5a81be69.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CREW_EXPERIENCE.png
// module id = 1145
// module chunks = 16